import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme => ({
    button: {
        borderRadius:'0.625rem',
        height:'3rem'
    }
}));

export default useStyles;